package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("kotlin_notebook")
@Composable
fun NoteBookKotlinPage() {

    BlogLayout(
        PageProperties(
            "NoteBook",
            "Kotlin Notebooks are interactive editors that a seamless coding, data Analysis (File Analysis, Data Source Connections), receive immediate outputs, and integrate code, visuals of graph, and text within the IntelliJ IDEA ecosystem."
        ),
        BlogProperties("Kotlin", "NoteBook")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            SpanText(
                text = "Basic Format",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //1 (Dependencies)
                    USE {
                        dependencies {
                           implementation("")
                           
                           //dependencies("org.mariadb.jdbc:mariadb-java-client:")
                        }
                    }
                    
                    //2 (File)
                    %use kotlin-sql-delight, jdbc
                    @file:DependsOn("org.postgresql:postgresql:")
                    
                    val url = "jdbc:postgresql://localhost:5432/your_database"
                    val user = ""
                    val password = ""

                    val connection: Connection = DriverManager.getConnection(url, user, password)
                    println("Connected to PostgreSQL!")
                    
                    connection.close()
                    """.trimIndent()
            )

            SpanText(
                text = "Add Dependencies",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    USE {
                        dependencies {
                           implementation("")
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "ktor API Calling",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                      %use serialization, ktor-client
                    
                      import  io.ktor.client.*;
                      import io.ktor.client.call.*
                      import io.ktor.client.plugins.contentnegotiation.*;
                      import io.ktor.serialization.kotlinx.json.*;
                      import io.ktor.client.request.*;
                      import io.ktor.client.statement.*;
                      import kotlinx.coroutines.runBlocking

                      val ktorClient = HttpClient() {
                          install(ContentNegotiation) {
                              json()
                          }
                      }

                      var response: HttpResponse
                      runBlocking {
                          response = ktorClient.get("https://pokeapi.co/api/v2/pokemon/ditto")
                      }

                      response.status
                """.trimIndent()
            )

            KotlinCode(
                code = """
                    //API calling JSON print
                    
                    %useLatestDescriptors

                    %use ktor-client
                   
                    val response = http.get("https://fumbbl.com/api/match/current")

                    val matches = response.deserializeJson()
                    matches
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    %use serialization

                    import kotlinx.serialization.Serializable

                    @Serializable
                    class User(val firstName: String, val lastName: String)

                    val bob = User("Alex", "Green")

                    Json { prettyPrint = true }.encodeToString(bob)
                    """.trimIndent()
            )

            SpanText(
                text = "Data Class Automatically Generate From API",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    %trackExecution

                    %use ktor-client, dataframe

                    import io.ktor.client.request.headers
                    import io.ktor.http.HttpHeaders
                    import io.ktor.http.append

                    val response = http.get("https://api.gainapis.com/v2/content/playlist/category?playlistLimit=100&videoLimit=100&cw=false&categoryId=pFlIW25nHIeRkjjIBLLg&lastPlaylistIndex=0") {
                        headers {
                            append("x-app-language", "TR")
                        }
                    }
                    
                    val deserializeJson = response.deserializeJson()
                    """.trimIndent()
            )

            SpanText(
                text = "kandy chart",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    %use kandy

                    import kotlin. random. Random
                    val map = mapOf<String, Int>("cat" to 10, "dog" to 6, "horse" to 6)

                    plot {
                        bars {
                            x (map. keys)
                            y (map. values)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "dataframe",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    %use dataframe

                    val ditto = DataFrame.read("https://pokeapi.co/api/v2/pokemon/ditto")

                    ditto
                    """.trimIndent()
            )
        }
    }
}

//https://gitlab.com/kurets/kotlin-notebook-post-sources/-/blob/main/notebooks/hotels-case.ipynb